import { createStore, del, entries, set } from "idb-keyval";
import type { PendingDrink } from "../domain/water";

/**
 * Drinks the service worker logged from a notification's +250 ml, waiting for the page (ADR-045).
 *
 * Shared by the worker and the page, which is why it is IndexedDB — the one store both can open;
 * the worker cannot touch the zustand store or localStorage. Every tap lands here first, before
 * the worker tries the server, so a tap with no network is still a drink the next time Kaya opens.
 * The server's inbox holds the same drink by the same id when the post got through; folding in by
 * id (`withDrinks`) makes the two one.
 */
const store = () => createStore("kaya-drinks", "queue");

export async function queueDrink(d: PendingDrink): Promise<void> {
  await set(d.id, d, store());
}

export async function queuedDrinks(): Promise<PendingDrink[]> {
  try {
    const all = await entries<string, PendingDrink>(store());
    return all.map(([, v]) => v).sort((a, b) => a.at - b.at);
  } catch {
    return [];
  }
}

export async function clearDrinks(ids: string[]): Promise<void> {
  const s = store();
  await Promise.all(ids.map((id) => del(id, s).catch(() => undefined)));
}
